module.exports = __webpack_public_path__ + "assets/devices/MKP-160-48b143920f0b3f6036bbc68feb61a26c.svg";